import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const useToaster = () => {
  const showToaster = ({ type = "info", message, options = {} }) => {
    toast[type](message, options);
  };

  return { showToaster };
};
